import { FC } from 'react'

import { EuiTitle, EuiFlexGroup, EuiFlexItem, EuiHorizontalRule, EuiText, EuiButtonIcon, EuiSpacer, EuiToolTip } from '@elastic/eui'

import { MasterCampaignPlanCustomSection } from 'api/interfaces/MasterCampaignPlan'
import SparklesIcon from 'features/planner/components/SparklesIcon'

export interface CustomizableSectionProps {
  section: MasterCampaignPlanCustomSection | null | undefined
  defaultTitle: string
  defaultContent: string
  defaultShowTitle: boolean
  separator: 'horizontalRule' | 'spacer'
  titleSize?: 's' | 'm' | 'l'
  onEdit?: () => void
  onAIEdit?: () => void
  onDelete: () => void
  showActions?: boolean
}

const CustomizableSection: FC<CustomizableSectionProps> = ({ section, defaultTitle, defaultContent, defaultShowTitle, separator, titleSize = 's', onEdit, onAIEdit, onDelete, showActions = true }) => {
  if (section?.hideAll === true) {
    return null
  }

  const title = section?.title ?? defaultTitle
  const content = section?.content ?? defaultContent
  const showTitle = section?.showTitle ?? defaultShowTitle

  const shouldShowTitle = showTitle && title && title.length > 0

  if (shouldShowTitle) {
    return (
      <>
        <EuiFlexGroup alignItems='center' gutterSize='s' responsive={false}>
          <EuiFlexItem grow={false}>
            <EuiTitle size='s'>
              <h4>{title}</h4>
            </EuiTitle>
          </EuiFlexItem>

          {showActions && (
            <>
              {onEdit && (
                <EuiFlexItem grow={false}>
                  <EuiButtonIcon iconType='pencil' style={{ color: '#0071c2' }} onClick={onEdit} aria-label='Edit' />
                </EuiFlexItem>
              )}

              {onAIEdit && (
                <EuiFlexItem grow={false}>
                  <EuiToolTip content='AI Edit'>
                    <EuiButtonIcon iconType={SparklesIcon} onClick={onAIEdit} aria-label='AI Edit' />
                  </EuiToolTip>
                </EuiFlexItem>
              )}

              <EuiButtonIcon iconType='trash' style={{ color: '#BD271E' }} onClick={onDelete} aria-label='Trash' />
            </>
          )}
        </EuiFlexGroup>

        {separator === 'spacer' && <EuiSpacer size='m' />}
        {separator === 'horizontalRule' && <EuiHorizontalRule margin='s' />}

        <EuiText style={{ whiteSpace: 'pre-wrap' }}>
          <p>{content}</p>
        </EuiText>
      </>
    )
  }

  return (
    <>
      <EuiText style={{ whiteSpace: 'pre-wrap' }}>
        <p>
          {content}

          {showActions && (
            <>
              {onEdit && <EuiButtonIcon style={{ marginLeft: '4px', color: '#0071c2' }} iconType='pencil' onClick={onEdit} aria-label='Edit' />}
              {onAIEdit && (
                <EuiToolTip content='AI Edit'>
                  <EuiButtonIcon style={{ marginLeft: '4px' }} iconType={SparklesIcon} onClick={onAIEdit} aria-label='AI Edit' />
                </EuiToolTip>
              )}
              <EuiButtonIcon style={{ marginLeft: '4px', color: '#BD271E' }} iconType='trash' onClick={onDelete} aria-label='Trash' />
            </>
          )}
        </p>
      </EuiText>
    </>
  )
}

export default CustomizableSection
